import React from 'react';

// Shown while a lazily-loaded route chunk is in flight (see the code-split
// route table in App.tsx).
//
// Deliberately empty. A spinner or a "Loading…" line would flash for a couple
// of hundred milliseconds on a normal connection and read as a broken page.
//
// The full viewport height is not decoration: it pushes the footer below the
// fold while the chunk is in flight, so the footer's move when real content
// lands happens off-screen and scores no layout shift. A shorter placeholder
// (70vh was measured) leaves the footer visible and shifts it down — CLS 0.22,
// well into "needs improvement" on a Core Web Vital.
const RouteFallback: React.FC = () => <div style={{ minHeight: '100vh' }} />;

export default RouteFallback;
